<template>
    <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
        <div v-if="this.isMobile">
            <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
        </div>
        <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
            Rename
        </div>
        <div v-if="!this.isMobile">
            <Icon name="close" class="c24 pointer" @click="this.close()"/>
        </div>
    </div>
    <div class="text-black bg-white rounded12" :class="{ 'p-0': this.isMobile, 'p24': !this.isMobile }">
        <div class="mb16">
            <div class="d-flex justify-content-between align-items-center mb8">
                <span class="fsp14 lh20 primary-grey">Network</span>
                <span class="fsp14 lh20 text-black neue">{{ this.addressData.network || '—' }}</span>
            </div>
        </div>
        <div class="mb16">
            <div class="d-flex justify-content-between align-items-center mb8">
                <span class="fsp14 lh20 primary-grey">Address</span>
                <span class="fsp14 lh20 text-black neue">{{ this.addressData.address || '—' }}</span>
            </div>
        </div>
        <div class="mb16">
            <div class="d-flex justify-content-between align-items-center mb8">
                <span class="fsp14 lh20 primary-grey">Status</span>
                <span class="fsp14 lh20 neue" :class="this.addressData.verified ? 'success-color' : 'text-black'">
                    <Icon v-if="this.addressData.verified" name="check" class="c16 mr4" />
                    {{ this.addressData.verified ? 'Verified' : 'Not Verified' }}
                </span>
            </div>
        </div>
        <div class="mb16">
            <div class="d-flex justify-content-between align-items-center mb8">
                <span class="fsp14 lh20 primary-grey">Address Type</span>
                <span class="fsp14 lh20 text-black neue">{{ this.getAddressType(this.addressData.ownership) }}</span>
            </div>
        </div>
        <div class="mb16">
            <div class="d-flex justify-content-between align-items-center mb8">
                <span class="fsp14 lh20 primary-grey">Recipient Type</span>
                <span class="fsp14 lh20 text-black neue">{{ this.addressData.user_type || '—' }}</span>
            </div>
        </div>
        <div v-if="this.addressData.user_type === 'personal'">
            <div class="mb16">
                <div class="d-flex justify-content-between align-items-center mb8">
                    <span class="fsp14 lh20 primary-grey">LEI</span>
                    <span class="fsp14 lh20 text-black neue">{{ this.addressData.user_fields?.lei || '—' }}</span>
                </div>
            </div>
            <div class="mb16">
                <div class="d-flex justify-content-between align-items-center mb8">
                    <span class="fsp14 lh20 primary-grey">Company Name</span>
                    <span class="fsp14 lh20 text-black neue">{{ this.addressData.user_fields?.name || '—' }}</span>
                </div>
            </div>
        </div>
        <div class="mb24">
            <div class="d-flex justify-content-between align-items-center mb8">
                <span class="fsp14 lh20 primary-grey">Wallet Name</span>
                <span class="fsp14 lh20 text-black neue">{{ this.addressData.name || '—' }}</span>
            </div>
        </div>
        <div class="mb24">
            <label class="fsp14 lh20 text-black mb8">Rename Wallet</label>
            <InputSimple
                id="wallet_name"
                :placeholder="'Enter new name wallet'"
                :dataValue="this.raname"
                @updateParentState="this.updateWalletName"
            />
        </div>
        <div class="d-flex align-items-center w-100" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
            <Button type="btn-outline-grey" class="equal-width h48 primary-grey mr16" @click="this.close()">Cancel</Button>
            <Button type="btn-warning" class="equal-width h48" @click="this.save()">Save</Button>
        </div>
    </div>
</template>
<script>
import Button from '@/components/service/Button.vue';
import InputSimple from '@/components/service/InputSimple.vue';
import Icon from '@/components/icons/Icon.vue';
export default {
    name: 'AddressDetails',
    components: {
        Button,
        InputSimple,
        Icon
    },
    props: {
        close: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            item: null,
            addressData: {},
            walletName: '',
            rename: ''
        }
    },
    created() {
        this.item = this.$store.state.modal.content.item;
        this.loadAddressData();
    },
    computed: {
        isMobile() {
            return this.$store.state.resize.w <= 768;
        }
    },
    methods: {
        loadAddressData() {
            this.axios.post('GetCryptoAddress', {
                data: {
                    address: this.item.address
                }
            }).then(res => {
                if (res.data.body && res.data.body.result != '0') {
                    return;
                }
                this.addressData = res.data.body.tables?.ownerships?.colvalues?.[0] || {};
                this.walletName = this.addressData.name || '';
            });
        },
        getAddressType(ownership) {
            const types = {
                'custodian': 'Custodian',
                'selfhosted_mine': 'Self-Hosted',
                'selfhosted_3dparty': 'Third Party Self-Hosted',
                'selfhosted_unknown': 'Self-Hosted Unknown',
                'not_found': 'Not Found'
            };
            return types[ownership] || '—';
        },
        updateWalletName(arg) {
            this.rename = arg.value;
        },
        save() {
            this.axios.post('UpdateCryptoAddress', {
                data: {
                    address: this.item.address,
                    name: this.rename
                }
            }).then(res => {
                if (res.data.body && res.data.body.result != '0') {
                    return;
                }
                if (this.$store.state.modal.content.callback) {
                    this.$store.state.modal.content.callback();
                }
                this.close();
                // Reload the addresses list if callback provided
            });
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
